// extracted by mini-css-extract-plugin
module.exports = {"deleteContainer":"delete-resource_deleteContainer__3XPDr","error":"delete-resource_error__3-UXY","actions":"delete-resource_actions__At7Nv"};